// tslint:disable
/**
 * LXBackend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface HandlerUrl
 */
export interface HandlerUrl {
    /**
     * 
     * @type {string}
     * @memberof HandlerUrl
     */
    handlerUrl: string;
}

export function HandlerUrlFromJSON(json: any): HandlerUrl {
    return {
        'handlerUrl': json['handler_url'],
    };
}

export function HandlerUrlToJSON(value?: HandlerUrl): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'handler_url': value.handlerUrl,
    };
}


